import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CheckCircleIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M64.4043333,29.4995556 L35.6298889,57.7562222 C34.0887778,59.2706667 31.5843333,59.2662222 30.0476667,57.7428889 L15.5843333,43.4117778 C14.8454444,42.6806667 14.4421111,41.7073333 14.4443333,40.6684444 C14.4465556,39.6295556 14.8554444,38.6573333 15.5954444,37.9306667 L17.3832222,36.1762222 C18.1521111,35.4206667 19.1598889,35.044 20.1676667,35.044 C21.181,35.044 22.1954444,35.4251111 22.9643333,36.1884444 L32.8654444,45.9984444 L57.0554444,22.244 C58.5987778,20.7273333 61.1021111,20.7351111 62.6376667,22.2562222 L64.4165556,24.0184444 C65.1532222,24.7484444 65.5576667,25.7228889 65.5554444,26.7617778 C65.5532222,27.7995556 65.1443333,28.7728889 64.4043333,29.4995556 M39.9998889,0.000666666667 C17.9076667,0.000666666667 -0.000111111111,17.9084444 -0.000111111111,40.0006667 C-0.000111111111,62.0917778 17.9076667,80.0006667 39.9998889,80.0006667 C62.091,80.0006667 79.9998889,62.0917778 79.9998889,40.0006667 C79.9998889,17.9084444 62.091,0.000666666667 39.9998889,0.000666666667"
      />
    </Icon>
  );
};

CheckCircleIcon.propTypes = {
  fill: PropTypes.string,
};

export default CheckCircleIcon;
